import React, { Component } from 'react';

import './Download.css';

import store from './imgs/app-store.svg';
import play from './imgs/google-play.svg';

class Download extends Component {
  render() {
    return (
      <div className="Download">
        <h2>It’s All On Your Phone</h2>
        <p>Download from Apple App Store or Google Play to begin the fun ride</p>
        <div className="Store">
          <button onClick={() => {window.open('https://itunes.apple.com/us/app/qbates/id1294026453?mt=8')}}>
              <img src={store} alt="APP STORE"/>
              <span>APP STORE</span>
          </button>

          <button onClick={() => {window.open('https://play.google.com/store/apps/details?id=com.qbatesapp.android')}}>
              <img src={play} alt="GOOGLE PLAY"/>
              <span>GOOGLE PLAY</span>
          </button>
        </div>
        <div className="Phones"/>
      </div>
    );
  }
}

export default Download;


// WEBPACK FOOTER //
// ./src/Containers/App/components/Download.js